import type { IconSvgObject } from './types';

const ArrowUpRight02Icon: IconSvgObject = [
  ["path", { d: "M14 10L6 18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11 7L18 6L17 13L11 7Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ArrowUpRight02Icon;
